import {
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
} from '@mui/material'
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter'
import { FC } from 'react'
import { useIntl } from 'react-intl'
import { ButtonLink } from '../../../../components/wrappers/Button'
import { TtoggleDrawerOnMobile } from '../../../../containers/Sidebar/Sidebar'

interface Props {
  pathname: string
  nested?: string
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
}

export const MenuBusinessApprovals: FC<Props> = ({
  pathname,
  nested,
  toggleDrawerOnMobile,
}) => {
  const intl = useIntl()
  return (
    <MenuList disablePadding={true} onClick={toggleDrawerOnMobile}>
      <MenuItem
        key="business-approvals"
        data-test="hr-bots_sidebar_menuitem"
        component={ButtonLink}
        href="/hr-bot/business-approvals?page=1"
        selected={pathname.includes('hr-bot/business-approvals')}
        className={nested}
      >
        <ListItemIcon data-test="hr-bot_sidemenu_icon">
          <BusinessCenterIcon />
        </ListItemIcon>
        <ListItemText
          primary={intl.formatMessage({
            id: 'business-approvals.sidebar',
          })}
        />
      </MenuItem>
    </MenuList>
  )
}
